import axios from "axios";
import * as ROUTES from "../constants/route";
import Helpers from "../components/Helpers";

const helpers = new Helpers();

const getAuthHeaders = () => ({
  Authorization: `Bearer ${helpers.getCookie("token")}`,
});

const getJsonHeaders = () => ({
  ...getAuthHeaders(),
  "Content-Type": "application/json",
});

export const getKycReviewStatus = () =>
  axios.get(`${ROUTES.FUNCTION_BASE_URL}v2/kyc-review/status`, {
    headers: getJsonHeaders(),
  });

export const getCurrentKycReview = () =>
  axios.get(`${ROUTES.FUNCTION_BASE_URL}v2/kyc-review/current`, {
    headers: getJsonHeaders(),
  });

export const uploadKycReviewAttachment = (imageType, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", imageType);

  return axios.post(
    `${ROUTES.FUNCTION_BASE_URL}v2/kyc-review/image`,
    formData,
    {
      headers: getAuthHeaders(),
    }
  );
};

export const submitKycReviewUpdate = (payload) =>
  axios.post(
    `${ROUTES.FUNCTION_BASE_URL}v2/kyc-review/update`,
    JSON.stringify(payload),
    {
      headers: getJsonHeaders(),
    }
  );
